import { render, staticRenderFns } from "./AndroidLogo.vue?vue&type=template&id=4c6a1bef&scoped=true"
import script from "./AndroidLogo.vue?vue&type=script&lang=js"
export * from "./AndroidLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6a1bef",
  null
  
)

export default component.exports